import { useTranslations } from "@/i18n/LocaleProvider";

export default function BatchConfirmedStep({ bookingReference }: { bookingReference: string }) {
  const { t } = useTranslations();
  return (
    <div className="mt-8 space-y-4">
      <h1 className="font-display text-3xl">{t("batches.confirmed.title")}</h1>
      <p>
        {t("batches.confirmed.noticeBefore")} <strong>{bookingReference}</strong>{" "}
        {t("batches.confirmed.noticeAfter")}
      </p>
    </div>
  );
}
